var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _NeuralAmpDeviceBoxAdapter_instances, _NeuralAmpDeviceBoxAdapter_context, _NeuralAmpDeviceBoxAdapter_box, _NeuralAmpDeviceBoxAdapter_parametric, _NeuralAmpDeviceBoxAdapter_wrapParameters;
import { Option, StringMapping, ValueMapping } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { DeviceManualUrls } from "../../DeviceManualUrls";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
import { NeuralAmpModelBoxAdapter } from "../../nam/NeuralAmpModelBoxAdapter";
export class NeuralAmpDeviceBoxAdapter {
    constructor(context, box) {
        _NeuralAmpDeviceBoxAdapter_instances.add(this);
        this.type = "audio-effect";
        this.accepts = "audio";
        this.manualUrl = DeviceManualUrls.NeuralAmp;
        _NeuralAmpDeviceBoxAdapter_context.set(this, void 0);
        _NeuralAmpDeviceBoxAdapter_box.set(this, void 0);
        _NeuralAmpDeviceBoxAdapter_parametric.set(this, void 0);
        __classPrivateFieldSet(this, _NeuralAmpDeviceBoxAdapter_context, context, "f");
        __classPrivateFieldSet(this, _NeuralAmpDeviceBoxAdapter_box, box, "f");
        __classPrivateFieldSet(this, _NeuralAmpDeviceBoxAdapter_parametric, new ParameterAdapterSet(__classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_context, "f")), "f");
        this.namedParameter = __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_instances, "m", _NeuralAmpDeviceBoxAdapter_wrapParameters).call(this, box);
    }
    get box() { return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").address; }
    get indexField() { return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").index; }
    get labelField() { return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").label; }
    get enabledField() { return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").enabled; }
    get minimizedField() { return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").minimized; }
    get host() { return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").host; }
    get modelField() { return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").model; }
    get monoField() { return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").mono; }
    get spectrum() { return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").address.append(0xFFF); }
    getModelAdapter() {
        const target = __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").model.targetVertex;
        if (target.isEmpty()) {
            return Option.None;
        }
        return Option.wrap(__classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_context, "f").boxAdapters.adapterFor(target.unwrap().box, NeuralAmpModelBoxAdapter));
    }
    getModelJson() {
        const modelAdapter = this.getModelAdapter();
        if (modelAdapter.nonEmpty()) {
            return modelAdapter.unwrap().getModelJson();
        }
        return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").modelJson.getValue();
    }
    deviceHost() {
        return __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_context, "f").boxAdapters
            .adapterFor(__classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_box, "f").host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    *labeledAudioOutputs() {
        yield { address: this.address, label: this.labelField.getValue(), children: () => Option.None };
    }
    terminate() {
        __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_parametric, "f").terminate();
    }
}
_NeuralAmpDeviceBoxAdapter_context = new WeakMap(), _NeuralAmpDeviceBoxAdapter_box = new WeakMap(), _NeuralAmpDeviceBoxAdapter_parametric = new WeakMap(), _NeuralAmpDeviceBoxAdapter_instances = new WeakSet(), _NeuralAmpDeviceBoxAdapter_wrapParameters = function _NeuralAmpDeviceBoxAdapter_wrapParameters(box) {
    return {
        inputGain: __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_parametric, "f").createParameter(box.inputGain, ValueMapping.decibel(-72.0, 0.0, 12.0), StringMapping.numeric({ unit: "dB", fractionDigits: 1 }), "Input"),
        outputGain: __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_parametric, "f").createParameter(box.outputGain, ValueMapping.decibel(-72.0, 0.0, 12.0), StringMapping.numeric({ unit: "dB", fractionDigits: 1 }), "Output"),
        mix: __classPrivateFieldGet(this, _NeuralAmpDeviceBoxAdapter_parametric, "f").createParameter(box.mix, ValueMapping.linear(0.0, 1.0), StringMapping.percent(), "Mix")
    };
};
